module.exports = __webpack_public_path__ + "images/bc32286df3c2f9cb9d2d3598bead2d78-logo.png";